import type { RootState } from "@/app/store";
import { TermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/TermoNotificacao";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TermoNotificacaoState {
  items: TermoNotificacao[];
}

const initialState: TermoNotificacaoState = {
  items: [],
};

const termoNotificacaoSlice = createSlice({
  name: "TERMO_NOTIFICACAO",
  initialState,
  reducers: {
    add: {
      reducer: (state, action: PayloadAction<{ item: TermoNotificacao }>) => {
        const { item } = action.payload;
        state.items.push({ ...item, offlineId: Date.now() });
      },
      prepare: (item: TermoNotificacao) => ({ payload: { item } }),
    },
    remove: {
      reducer: (state, action: PayloadAction<{ offlineId: number }>) => {
        state.items = state.items.filter(
          (item) => item.offlineId !== action.payload.offlineId
        );
      },
      prepare: (offlineId: number) => ({ payload: { offlineId } }),
    },
    update: {
      reducer: (state, action: PayloadAction<{ item: TermoNotificacao }>) => {
        const index = state.items.findIndex(
          (item) => item.offlineId === action.payload.item.offlineId
        );
        state.items[index] = action.payload.item;
      },
      prepare: (item: TermoNotificacao) => ({ payload: { item } }),
    },
  },
});

export const termoNotificacaoAction = termoNotificacaoSlice.actions;

export default termoNotificacaoSlice.reducer;

export const getTermosNotificacao = (state: RootState) => {
  const listaInvertida = state.termoNotificacao.items.map((_, ind, lista) => {
    return lista[lista.length - ind - 1];
  });

  return listaInvertida;
};
